<template>
  <div class="about-container">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('About Us') }}</h1>
      <div class="placeholder"></div>
    </div>
    
    <!-- 内容区域 -->
    <div class="content">
      <!-- 顶部蓝色背景区域 -->
      <div class="header-section">
        <img src="/static/image/yunchuan-logo.png" alt="云川国际" class="logo">
      </div>
      
      <!-- 内容显示区域 -->
      <div class="content-section">
        <div class="content-body">
          <div v-if="loading" class="loading">{{ $t('Loading...') }}</div>
          <div v-else-if="error" class="error">{{ error }}</div>
          
          <!-- 直接使用模板渲染多语言，替代原来的 v-html -->
          <div v-else class="about-content">
            <p class="company-info">{{ $t('Company Intro 1') }}</p>
            
            <h3>{{ $t('Company Profile') }}</h3>
            <p>About Company</p>
            <p>{{ $t('Company Intro 2') }}</p>
            
            <h3>{{ $t('Payment Methods') }}</h3>
            <p>Payment</p>
            <p>{{ $t('Payment Desc') }}</p>
            
            <h3>{{ $t('Customer Service Title') }}</h3>
            <p>Customer Service</p>
            <p>{{ $t('CS Desc') }}</p>
            <ol>
              <li>{{ $t('CS Point 1') }}</li>
              <li>{{ $t('CS Point 2') }}</li>
              <li>{{ $t('CS Point 3') }}</li>
            </ol>
            
            <h3>{{ $t('Safe and Trustworthy Title') }}</h3>
            <p>Safe and Trustworthy</p>
            <p>{{ $t('Safe Desc') }}</p>
            
            <h3>{{ $t('Our Service Title') }}</h3>
            <p>Our Service</p>
            <p>{{ $t('Service Desc') }}</p>
            
            <h3>{{ $t('Vision Title') }}</h3>
            <p>Our Vision</p>
            <p>{{ $t('Vision Desc') }}</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data() {
    return {
      loading: false,
      error: ''
    };
  },
  created() {
    // 页面加载时模拟请求延迟
    this.loadAboutContent();
  },
  methods: {
    loadAboutContent() {
      this.loading = true;
      this.error = '';
      
      // 模拟接口请求时间
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style scoped>
.about-container {
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #333;
}

.top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background-color: #054dc4;
  color: white;
  position: sticky;
  top: 0;
  z-index: 100;
}

.top-nav h1 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #fff;
}

.back {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  i {
    font-size: 20px;
    color: #fff;
    transition: all 0.3s ease;
  }
  
  &:hover i {
    transform: translateX(-2px);
  }
}

.placeholder {
  width: 44px;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.header-section {
  background: linear-gradient(135deg, #054dc4, #054dc4);
  padding: 60px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.header-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.5;
}

.logo {
  width: 128px;
  height: 128px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.menu-list {
  background-color: #fff;
  margin: 20px 0;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  span {
    font-size: 16px;
    color: #333;
  }
  
  i {
    font-size: 14px;
    color: #999;
  }
}

.content-section {
  background-color: #fff;
  
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  min-height: 300px;
}

.content-header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #f9f9f9;
}

.back-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #054dc4;
  margin-right: 20px;
  
  i {
    margin-right: 5px;
  }
  
  &:hover {
    opacity: 0.8;
  }
}

.content-header h2 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.content-body {
  padding: 20px;
  line-height: 1.6;
  color: #333;
  min-height: 200px;
}

.loading,
.error {
  text-align: center;
  padding: 40px 0;
  color: #666;
}

.about-content {
  line-height: 1.8;
  color: #333;
  
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 15px;
    color: #054dc4;
  }
  
  h3:first-child {
    margin-top: 0;
  }
  
  p {
    margin-bottom: 15px;
  }
  
  ol {
    margin-left: 20px;
    margin-bottom: 15px;
  }
  
  li {
    margin-bottom: 8px;
  }
  
  .company-info {
    font-weight: 500;
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .header-section {
    padding: 40px 0;
  }
  
  .logo {
    width: 108px;
    height: 108px;
  }
  
  .menu-item {
    padding: 12px 15px;
    
    span {
      font-size: 15px;
    }
  }
  
  .content-header {
    padding: 12px 15px;
    
    h2 {
      font-size: 15px;
    }
  }
  
  .content-body {
    padding: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about.vue